export class UnknownPayloadTypeError extends Error {
    constructor(type: string) {
        super(`Unknown value in payload type field '${type}'`); // (1)
        this.name = 'UnknownPayloadTypeError'; // (2)
    }
}
